import { default as activationgYsbfIeAkPMeta } from "/project/pages/activation.vue?macro=true";
import { default as index9HCIah9pSRMeta } from "/project/pages/battlepass/[id]/index.vue?macro=true";
import { default as indexGJ4dw6qZYAMeta } from "/project/pages/battlepass/index.vue?macro=true";
import { default as callbackI7cf9WIBuGMeta } from "/project/pages/callback.vue?macro=true";
import { default as _91id_93xh8SLCzONoMeta } from "/project/pages/fantasy/[id].vue?macro=true";
import { default as indexNrErSrpuiCMeta } from "/project/pages/fantasy/all/index.vue?macro=true";
import { default as indexDnfX7BYdQdMeta } from "/project/pages/fantasy/collection/index.vue?macro=true";
import { default as use_45fantasy_45all_45routetlzAOsc8evMeta } from "/project/pages/fantasy/composables/use-fantasy-all-route.ts?macro=true";
import { default as use_45fantasy_45allO7EWKATnIrMeta } from "/project/pages/fantasy/composables/use-fantasy-all.ts?macro=true";
import { default as use_45fantasy_45page_45initVgPwdViUFdMeta } from "/project/pages/fantasy/composables/use-fantasy-page-init.ts?macro=true";
import { default as use_45fantasy_45welcome_45guideZ16l6IQ6DTMeta } from "/project/pages/fantasy/composables/use-fantasy-welcome-guide.ts?macro=true";
import { default as indexFt9KmJAq2uMeta } from "/project/pages/fantasy/index.vue?macro=true";
import { default as indexrM0Rh2s5LIMeta } from "/project/pages/fantasy/shop/index.vue?macro=true";
import { default as index5GDnY66y5IMeta } from "/project/pages/index.vue?macro=true";
import { default as _91id_936T0yPiYS86Meta } from "/project/pages/news/[id].vue?macro=true";
import { default as indexQXNeuTBpi7Meta } from "/project/pages/news/index.vue?macro=true";
import { default as config8wOdcdikRHMeta } from "/project/pages/pages/[slug]/config.ts?macro=true";
import { default as index1K2PgmRkULMeta } from "/project/pages/pages/[slug]/index.vue?macro=true";
import { default as _91id_93z436Y6tGFBMeta } from "/project/pages/pickem/[id].vue?macro=true";
import { default as index7hdowLJtOeMeta } from "/project/pages/pickem/all/index.vue?macro=true";
import { default as indexCtNj3BG0KGMeta } from "/project/pages/pickem/index.vue?macro=true";
import { default as achievementsWSh7WboHIKMeta } from "/project/pages/profile/[id]/achievements.vue?macro=true";
import { default as indexW0O1dDDZxWMeta } from "/project/pages/profile/[id]/index.vue?macro=true";
import { default as indexyxOugkp29aMeta } from "/project/pages/profile/index.vue?macro=true";
import { default as indexLWni1nomVxMeta } from "/project/pages/profile/settings/index/index.vue?macro=true";
import { default as referralshvfkg53iUTMeta } from "/project/pages/profile/settings/index/referrals.vue?macro=true";
import { default as taskCSreOZsFcwMeta } from "/project/pages/profile/settings/index/task.vue?macro=true";
import { default as indexpdh8K3Ui9uMeta } from "/project/pages/profile/settings/index.vue?macro=true";
import { default as indexcMgYRxzgeUMeta } from "/project/pages/ratings/index.vue?macro=true";
import { default as _91category_93V2ztLba1RfMeta } from "/project/pages/shop/index/[category].vue?macro=true";
import { default as indexvt5dghFjiOMeta } from "/project/pages/shop/index/index.vue?macro=true";
import { default as indexFTF1Ld1gczMeta } from "/project/pages/shop/index.vue?macro=true";
import { default as index4L0OhE0mvTMeta } from "/project/pages/squads/[id]/index.vue?macro=true";
import { default as indexooncwZhL8wMeta } from "/project/pages/squads/index.vue?macro=true";
import { default as activeBHwjhVIXnEMeta } from "/project/pages/squads/races/active.vue?macro=true";
import { default as alluascXFnf6lMeta } from "/project/pages/squads/races/all.vue?macro=true";
import { default as _91id_93cCU5wDXaa8Meta } from "/project/pages/squads/races/finished/[id].vue?macro=true";
import { default as upcomingDpQQ5l8ycjMeta } from "/project/pages/squads/races/upcoming.vue?macro=true";
import { default as typeshx5K8e4jFGMeta } from "/project/pages/types.ts?macro=true";
export default [
  {
    name: activationgYsbfIeAkPMeta?.name ?? "activation",
    path: activationgYsbfIeAkPMeta?.path ?? "/activation",
    meta: activationgYsbfIeAkPMeta || {},
    alias: activationgYsbfIeAkPMeta?.alias || [],
    redirect: activationgYsbfIeAkPMeta?.redirect,
    component: () => import("/project/pages/activation.vue").then(m => m.default || m)
  },
  {
    name: index9HCIah9pSRMeta?.name ?? "battlepass-id",
    path: index9HCIah9pSRMeta?.path ?? "/battlepass/:id()",
    meta: index9HCIah9pSRMeta || {},
    alias: index9HCIah9pSRMeta?.alias || [],
    redirect: index9HCIah9pSRMeta?.redirect,
    component: () => import("/project/pages/battlepass/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexGJ4dw6qZYAMeta?.name ?? "battlepass",
    path: indexGJ4dw6qZYAMeta?.path ?? "/battlepass",
    meta: indexGJ4dw6qZYAMeta || {},
    alias: indexGJ4dw6qZYAMeta?.alias || [],
    redirect: indexGJ4dw6qZYAMeta?.redirect,
    component: () => import("/project/pages/battlepass/index.vue").then(m => m.default || m)
  },
  {
    name: callbackI7cf9WIBuGMeta?.name ?? "callback",
    path: callbackI7cf9WIBuGMeta?.path ?? "/callback",
    meta: callbackI7cf9WIBuGMeta || {},
    alias: callbackI7cf9WIBuGMeta?.alias || [],
    redirect: callbackI7cf9WIBuGMeta?.redirect,
    component: () => import("/project/pages/callback.vue").then(m => m.default || m)
  },
  {
    name: _91id_93xh8SLCzONoMeta?.name ?? "fantasy-id",
    path: _91id_93xh8SLCzONoMeta?.path ?? "/fantasy/:id()",
    meta: _91id_93xh8SLCzONoMeta || {},
    alias: _91id_93xh8SLCzONoMeta?.alias || [],
    redirect: _91id_93xh8SLCzONoMeta?.redirect,
    component: () => import("/project/pages/fantasy/[id].vue").then(m => m.default || m)
  },
  {
    name: indexNrErSrpuiCMeta?.name ?? "fantasy-all",
    path: indexNrErSrpuiCMeta?.path ?? "/fantasy/all",
    meta: indexNrErSrpuiCMeta || {},
    alias: indexNrErSrpuiCMeta?.alias || [],
    redirect: indexNrErSrpuiCMeta?.redirect,
    component: () => import("/project/pages/fantasy/all/index.vue").then(m => m.default || m)
  },
  {
    name: indexDnfX7BYdQdMeta?.name ?? "fantasy-collection",
    path: indexDnfX7BYdQdMeta?.path ?? "/fantasy/collection",
    meta: indexDnfX7BYdQdMeta || {},
    alias: indexDnfX7BYdQdMeta?.alias || [],
    redirect: indexDnfX7BYdQdMeta?.redirect,
    component: () => import("/project/pages/fantasy/collection/index.vue").then(m => m.default || m)
  },
  {
    name: use_45fantasy_45all_45routetlzAOsc8evMeta?.name ?? "fantasy-composables-use-fantasy-all-route",
    path: use_45fantasy_45all_45routetlzAOsc8evMeta?.path ?? "/fantasy/composables/use-fantasy-all-route",
    meta: use_45fantasy_45all_45routetlzAOsc8evMeta || {},
    alias: use_45fantasy_45all_45routetlzAOsc8evMeta?.alias || [],
    redirect: use_45fantasy_45all_45routetlzAOsc8evMeta?.redirect,
    component: () => import("/project/pages/fantasy/composables/use-fantasy-all-route.ts").then(m => m.default || m)
  },
  {
    name: use_45fantasy_45allO7EWKATnIrMeta?.name ?? "fantasy-composables-use-fantasy-all",
    path: use_45fantasy_45allO7EWKATnIrMeta?.path ?? "/fantasy/composables/use-fantasy-all",
    meta: use_45fantasy_45allO7EWKATnIrMeta || {},
    alias: use_45fantasy_45allO7EWKATnIrMeta?.alias || [],
    redirect: use_45fantasy_45allO7EWKATnIrMeta?.redirect,
    component: () => import("/project/pages/fantasy/composables/use-fantasy-all.ts").then(m => m.default || m)
  },
  {
    name: use_45fantasy_45page_45initVgPwdViUFdMeta?.name ?? "fantasy-composables-use-fantasy-page-init",
    path: use_45fantasy_45page_45initVgPwdViUFdMeta?.path ?? "/fantasy/composables/use-fantasy-page-init",
    meta: use_45fantasy_45page_45initVgPwdViUFdMeta || {},
    alias: use_45fantasy_45page_45initVgPwdViUFdMeta?.alias || [],
    redirect: use_45fantasy_45page_45initVgPwdViUFdMeta?.redirect,
    component: () => import("/project/pages/fantasy/composables/use-fantasy-page-init.ts").then(m => m.default || m)
  },
  {
    name: use_45fantasy_45welcome_45guideZ16l6IQ6DTMeta?.name ?? "fantasy-composables-use-fantasy-welcome-guide",
    path: use_45fantasy_45welcome_45guideZ16l6IQ6DTMeta?.path ?? "/fantasy/composables/use-fantasy-welcome-guide",
    meta: use_45fantasy_45welcome_45guideZ16l6IQ6DTMeta || {},
    alias: use_45fantasy_45welcome_45guideZ16l6IQ6DTMeta?.alias || [],
    redirect: use_45fantasy_45welcome_45guideZ16l6IQ6DTMeta?.redirect,
    component: () => import("/project/pages/fantasy/composables/use-fantasy-welcome-guide.ts").then(m => m.default || m)
  },
  {
    name: indexFt9KmJAq2uMeta?.name ?? "fantasy",
    path: indexFt9KmJAq2uMeta?.path ?? "/fantasy",
    meta: indexFt9KmJAq2uMeta || {},
    alias: indexFt9KmJAq2uMeta?.alias || [],
    redirect: indexFt9KmJAq2uMeta?.redirect,
    component: () => import("/project/pages/fantasy/index.vue").then(m => m.default || m)
  },
  {
    name: indexrM0Rh2s5LIMeta?.name ?? "fantasy-shop",
    path: indexrM0Rh2s5LIMeta?.path ?? "/fantasy/shop",
    meta: indexrM0Rh2s5LIMeta || {},
    alias: indexrM0Rh2s5LIMeta?.alias || [],
    redirect: indexrM0Rh2s5LIMeta?.redirect,
    component: () => import("/project/pages/fantasy/shop/index.vue").then(m => m.default || m)
  },
  {
    name: index5GDnY66y5IMeta?.name ?? "index",
    path: index5GDnY66y5IMeta?.path ?? "/",
    meta: index5GDnY66y5IMeta || {},
    alias: index5GDnY66y5IMeta?.alias || [],
    redirect: index5GDnY66y5IMeta?.redirect,
    component: () => import("/project/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_936T0yPiYS86Meta?.name ?? "news-id",
    path: _91id_936T0yPiYS86Meta?.path ?? "/news/:id()",
    meta: _91id_936T0yPiYS86Meta || {},
    alias: _91id_936T0yPiYS86Meta?.alias || [],
    redirect: _91id_936T0yPiYS86Meta?.redirect,
    component: () => import("/project/pages/news/[id].vue").then(m => m.default || m)
  },
  {
    name: indexQXNeuTBpi7Meta?.name ?? "news",
    path: indexQXNeuTBpi7Meta?.path ?? "/news",
    meta: indexQXNeuTBpi7Meta || {},
    alias: indexQXNeuTBpi7Meta?.alias || [],
    redirect: indexQXNeuTBpi7Meta?.redirect,
    component: () => import("/project/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: config8wOdcdikRHMeta?.name ?? "pages-slug-config",
    path: config8wOdcdikRHMeta?.path ?? "/pages/:slug()/config",
    meta: config8wOdcdikRHMeta || {},
    alias: config8wOdcdikRHMeta?.alias || [],
    redirect: config8wOdcdikRHMeta?.redirect,
    component: () => import("/project/pages/pages/[slug]/config.ts").then(m => m.default || m)
  },
  {
    name: index1K2PgmRkULMeta?.name ?? "pages-slug",
    path: index1K2PgmRkULMeta?.path ?? "/pages/:slug()",
    meta: index1K2PgmRkULMeta || {},
    alias: index1K2PgmRkULMeta?.alias || [],
    redirect: index1K2PgmRkULMeta?.redirect,
    component: () => import("/project/pages/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93z436Y6tGFBMeta?.name ?? "pickem-id",
    path: _91id_93z436Y6tGFBMeta?.path ?? "/pickem/:id()",
    meta: _91id_93z436Y6tGFBMeta || {},
    alias: _91id_93z436Y6tGFBMeta?.alias || [],
    redirect: _91id_93z436Y6tGFBMeta?.redirect,
    component: () => import("/project/pages/pickem/[id].vue").then(m => m.default || m)
  },
  {
    name: index7hdowLJtOeMeta?.name ?? "pickem-all",
    path: index7hdowLJtOeMeta?.path ?? "/pickem/all",
    meta: index7hdowLJtOeMeta || {},
    alias: index7hdowLJtOeMeta?.alias || [],
    redirect: index7hdowLJtOeMeta?.redirect,
    component: () => import("/project/pages/pickem/all/index.vue").then(m => m.default || m)
  },
  {
    name: indexCtNj3BG0KGMeta?.name ?? "pickem",
    path: indexCtNj3BG0KGMeta?.path ?? "/pickem",
    meta: indexCtNj3BG0KGMeta || {},
    alias: indexCtNj3BG0KGMeta?.alias || [],
    redirect: indexCtNj3BG0KGMeta?.redirect,
    component: () => import("/project/pages/pickem/index.vue").then(m => m.default || m)
  },
  {
    name: achievementsWSh7WboHIKMeta?.name ?? "profile-id-achievements",
    path: achievementsWSh7WboHIKMeta?.path ?? "/profile/:id()/achievements",
    meta: achievementsWSh7WboHIKMeta || {},
    alias: achievementsWSh7WboHIKMeta?.alias || [],
    redirect: achievementsWSh7WboHIKMeta?.redirect,
    component: () => import("/project/pages/profile/[id]/achievements.vue").then(m => m.default || m)
  },
  {
    name: indexW0O1dDDZxWMeta?.name ?? "profile-id",
    path: indexW0O1dDDZxWMeta?.path ?? "/profile/:id()",
    meta: indexW0O1dDDZxWMeta || {},
    alias: indexW0O1dDDZxWMeta?.alias || [],
    redirect: indexW0O1dDDZxWMeta?.redirect,
    component: () => import("/project/pages/profile/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexyxOugkp29aMeta?.name ?? "profile",
    path: indexyxOugkp29aMeta?.path ?? "/profile",
    meta: indexyxOugkp29aMeta || {},
    alias: indexyxOugkp29aMeta?.alias || [],
    redirect: indexyxOugkp29aMeta?.redirect,
    component: () => import("/project/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexpdh8K3Ui9uMeta?.name ?? undefined,
    path: indexpdh8K3Ui9uMeta?.path ?? "/profile/settings",
    meta: indexpdh8K3Ui9uMeta || {},
    alias: indexpdh8K3Ui9uMeta?.alias || [],
    redirect: indexpdh8K3Ui9uMeta?.redirect,
    component: () => import("/project/pages/profile/settings/index.vue").then(m => m.default || m),
    children: [
  {
    name: indexLWni1nomVxMeta?.name ?? "profile-settings-index",
    path: indexLWni1nomVxMeta?.path ?? "",
    meta: indexLWni1nomVxMeta || {},
    alias: indexLWni1nomVxMeta?.alias || [],
    redirect: indexLWni1nomVxMeta?.redirect,
    component: () => import("/project/pages/profile/settings/index/index.vue").then(m => m.default || m)
  },
  {
    name: referralshvfkg53iUTMeta?.name ?? "profile-settings-index-referrals",
    path: referralshvfkg53iUTMeta?.path ?? "referrals",
    meta: referralshvfkg53iUTMeta || {},
    alias: referralshvfkg53iUTMeta?.alias || [],
    redirect: referralshvfkg53iUTMeta?.redirect,
    component: () => import("/project/pages/profile/settings/index/referrals.vue").then(m => m.default || m)
  },
  {
    name: taskCSreOZsFcwMeta?.name ?? "profile-settings-index-task",
    path: taskCSreOZsFcwMeta?.path ?? "task",
    meta: taskCSreOZsFcwMeta || {},
    alias: taskCSreOZsFcwMeta?.alias || [],
    redirect: taskCSreOZsFcwMeta?.redirect,
    component: () => import("/project/pages/profile/settings/index/task.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexcMgYRxzgeUMeta?.name ?? "ratings",
    path: indexcMgYRxzgeUMeta?.path ?? "/ratings",
    meta: indexcMgYRxzgeUMeta || {},
    alias: indexcMgYRxzgeUMeta?.alias || [],
    redirect: indexcMgYRxzgeUMeta?.redirect,
    component: () => import("/project/pages/ratings/index.vue").then(m => m.default || m)
  },
  {
    name: indexFTF1Ld1gczMeta?.name ?? undefined,
    path: indexFTF1Ld1gczMeta?.path ?? "/shop",
    meta: indexFTF1Ld1gczMeta || {},
    alias: indexFTF1Ld1gczMeta?.alias || [],
    redirect: indexFTF1Ld1gczMeta?.redirect,
    component: () => import("/project/pages/shop/index.vue").then(m => m.default || m),
    children: [
  {
    name: _91category_93V2ztLba1RfMeta?.name ?? "shop-index-category",
    path: _91category_93V2ztLba1RfMeta?.path ?? ":category()",
    meta: _91category_93V2ztLba1RfMeta || {},
    alias: _91category_93V2ztLba1RfMeta?.alias || [],
    redirect: _91category_93V2ztLba1RfMeta?.redirect,
    component: () => import("/project/pages/shop/index/[category].vue").then(m => m.default || m)
  },
  {
    name: indexvt5dghFjiOMeta?.name ?? "shop-index",
    path: indexvt5dghFjiOMeta?.path ?? "",
    meta: indexvt5dghFjiOMeta || {},
    alias: indexvt5dghFjiOMeta?.alias || [],
    redirect: indexvt5dghFjiOMeta?.redirect,
    component: () => import("/project/pages/shop/index/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: index4L0OhE0mvTMeta?.name ?? "squads-id",
    path: index4L0OhE0mvTMeta?.path ?? "/squads/:id()",
    meta: index4L0OhE0mvTMeta || {},
    alias: index4L0OhE0mvTMeta?.alias || [],
    redirect: index4L0OhE0mvTMeta?.redirect,
    component: () => import("/project/pages/squads/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexooncwZhL8wMeta?.name ?? "squads",
    path: indexooncwZhL8wMeta?.path ?? "/squads",
    meta: indexooncwZhL8wMeta || {},
    alias: indexooncwZhL8wMeta?.alias || [],
    redirect: indexooncwZhL8wMeta?.redirect,
    component: () => import("/project/pages/squads/index.vue").then(m => m.default || m)
  },
  {
    name: activeBHwjhVIXnEMeta?.name ?? "squads-races-active",
    path: activeBHwjhVIXnEMeta?.path ?? "/squads/races/active",
    meta: activeBHwjhVIXnEMeta || {},
    alias: activeBHwjhVIXnEMeta?.alias || [],
    redirect: activeBHwjhVIXnEMeta?.redirect,
    component: () => import("/project/pages/squads/races/active.vue").then(m => m.default || m)
  },
  {
    name: alluascXFnf6lMeta?.name ?? "squads-races-all",
    path: alluascXFnf6lMeta?.path ?? "/squads/races/all",
    meta: alluascXFnf6lMeta || {},
    alias: alluascXFnf6lMeta?.alias || [],
    redirect: alluascXFnf6lMeta?.redirect,
    component: () => import("/project/pages/squads/races/all.vue").then(m => m.default || m)
  },
  {
    name: _91id_93cCU5wDXaa8Meta?.name ?? "squads-races-finished-id",
    path: _91id_93cCU5wDXaa8Meta?.path ?? "/squads/races/finished/:id()",
    meta: _91id_93cCU5wDXaa8Meta || {},
    alias: _91id_93cCU5wDXaa8Meta?.alias || [],
    redirect: _91id_93cCU5wDXaa8Meta?.redirect,
    component: () => import("/project/pages/squads/races/finished/[id].vue").then(m => m.default || m)
  },
  {
    name: upcomingDpQQ5l8ycjMeta?.name ?? "squads-races-upcoming",
    path: upcomingDpQQ5l8ycjMeta?.path ?? "/squads/races/upcoming",
    meta: upcomingDpQQ5l8ycjMeta || {},
    alias: upcomingDpQQ5l8ycjMeta?.alias || [],
    redirect: upcomingDpQQ5l8ycjMeta?.redirect,
    component: () => import("/project/pages/squads/races/upcoming.vue").then(m => m.default || m)
  },
  {
    name: typeshx5K8e4jFGMeta?.name ?? "types",
    path: typeshx5K8e4jFGMeta?.path ?? "/types",
    meta: typeshx5K8e4jFGMeta || {},
    alias: typeshx5K8e4jFGMeta?.alias || [],
    redirect: typeshx5K8e4jFGMeta?.redirect,
    component: () => import("/project/pages/types.ts").then(m => m.default || m)
  }
]